import en from 'vuetify/lib/locale/en'

// Usage -> {{t('$vuetify.close')}} -> 關閉

// Usage in vuex store ->
// import Vuetify from '@/plugins/vuetify'
// Vuetify.locale.t('$vuetify.close')

// For variable -> {{t('$vuetify.__XXX.abc', 'world')}}
// In lang file, __XXX:{abc: 'Hello {0}'} -> result: 'Hello world'
// If no variable needed for certain case, still require empty string -> {{t('$vuetify.__XXX.abc', '')}}

// Multiple variables -> {{t('$vuetify.__XXX.abc', 'Hello', 'world', '!')}}
// In lang file, __XXX:{abc: '{0} {1}{2}'} -> result: 'Hello world!'

export default {
  ...en,
  __General: {
    device: 'Device',
    reset: 'Reset',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    done: 'Done',
    edit: 'Edit',
    update: 'Update',
    refresh: 'Refresh',
    on: 'On',
    off: 'Off',
    remove: 'Remove',
    back: 'Back',
    category: 'Category',
    rename: 'Rename',
    name: 'Name',
    change: 'Change',
    add: 'Add',
    yes: 'Yes',
    no: 'No',
    none: 'None',
    submit: 'Submit',
    description: 'Description',
    display_content: 'Display Content',
    question_topic: 'Question Topic',
    add_question_topic: 'Add Question Topic',
    add_sub_topic: 'Add Sub Topic',
    tag_input_hint: 'Type and press enter to input',
    remarks: 'Remarks',
    filepond: {
      add_image_banner: 'Add Image Banner',
      upload_file: 'Upload File',
      hint: 'Drag & Drop your File Here or Browse...',
      png_hint: 'Drag & Drop your PNG image Here or Browse...',
      banner_hint: 'Drag & Drop your Banner Here or Browse...'
    },
    file: 'File',
    upload: 'Upload',
    image: 'Image',
    images: 'Images',
    new: 'New',
    language: 'Language',
    save: 'save',
    info: 'Info',
    video: 'Video',
    motion_selection_title: 'Play virual avatar motion',
    browse_motions: 'Browse motions',
    select_motion: 'Select Motion...',
    remaining_characters: 'Remaining Characters {0}/{1}',
    remaining_words: 'Remaining Words {0}/{1}',
    selection_button: 'Selection Button',
    number_of_column: 'Number of Column',
    row: 'Row',
    add_row: 'Add Row',
    name_of_button: 'Name of Button',
    name_hint: 'Used to identify the button',
    trigger_keyword: 'Trigger Keyword',
    trigger_hint: 'What to respond when the button is clicked',
    empty: 'empty',
    motion_dialog: {
      animation_preview: 'Animation Preview',
      hint: 'Click the file name to play animation',
      action_gesture: 'Action & Gesture',
      idle_motion: 'Idle Motion',
      lip_sync: 'Lip Sync Animation',
      lip_sync_hint: 'Select a Lip Sync sentence to play with action',
      animation: 'Animation',
      animation_hint: 'Click and drag to move character’s direction',
      virtual_avatar_motion: 'Virtual Avatar Motion'
    }
  },
  __Lang: {
    chinese: 'Chinese',
    cantonese: 'Cantonese',
    mandarin: 'Mandarin',
    english: 'English',
    japanese: 'Japanese',
    korean: 'Korean',
    vietnamese: 'Vietnamese',
    thai: 'Thai',
    deutsch: 'Deutsch'
  },
  __Rules: {
    words: 'Min {0} words, Max {1} words',
    characters: 'Min {0} characters, Max {1} characters',
    category_name: 'Category Name is required',
    topic_name: 'Topic Name is required',
    select_category: 'Please select a category',
    destination_device: 'Destination Device is needed',
    field: 'Field required!',
    required: 'Required!',
    role: 'Role is required',
    name: 'Name is required',
    username: 'Username is required',
    project_name: 'Project Name is required',
    avatar_name: 'Avatar Name is required',
    password: 'Password is required',
    confirm_password: 'Confirm password is not same as password',
    minimum_1: 'Min. 1',
    max_characters: 'Maximum {0} characters'
  },
  __Login: {
    panel_title: 'Bot Admin Panel',
    project: 'Project',
    username: 'Username',
    password: 'Password',
    login: 'Login'
  },
  __Router: {
    dashboard: 'Dashboard',
    chat: 'Live Chat',
    live_video: 'Live Video',
    message: 'Message',
    ai: 'AI Configuration',
    talk: 'Small Talk',
    conversation: 'Conversation Review',
    event: 'Event Manager',
    interface: 'Interface Setting',
    setting: 'Admin Setting'
  },
  __LeftBar: {
    search_device: 'Search device',
    no_device_found: 'No matching device',
    transfer_tooltip_text: 'Transfer A.I. Data to other devices',
    transfer_ai_data: 'Transfer A.I. Data',
    transfer_from: 'Transfer A.I. Data from',
    select_device: 'Select destination device',
    transfer_hint: 'This will replace all the Data and Setting of the destination device.',
    admin: 'Admin',
    logout: 'Logout',
    submit_changes: 'Submit Changes',
    backup_now: 'Backup now',
    backup_hint: 'Press copy the following password for the zip file'
  },
  __Dashboard: {
    show_report_of: 'Show Report Of',
    conversations: 'Conversations',
    fallback: 'Fallback Conversations',
    q_and_a: 'Q&A Sessions',
    tokens: 'Tokens',
    used: 'Used',
    conversation_count: 'Count of Conversation by Time of Day',
    top_10_faq: 'Top 10 Most Frequently Asked Questions',
    counts: 'Counts',
    expand: 'Expand',
    shrink: 'Shrink',
    funnel_title: 'Botisfy Funnel',
    funnel_proxy_note: '* proxy value (precise data pending event tracking)',
    funnel_error: 'Failed to load funnel',
    opened_sessions: 'Opened Sessions',
    engaged_sessions: 'Engaged Sessions',
    answered_turns: 'Answered Turns',
    avg_turns_per_engaged_session: 'Avg. Turns per Engaged Session',
    opened_sessions_tooltip: 'How many times users opened the chatbot or started a session. May include users who only saw the welcome message, language selection, or disclaimer before asking.',
    engaged_sessions_tooltip: 'Sessions with at least one real interaction, such as selecting a language, accepting the disclaimer, clicking a button, or typing a message.',
    answered_turns_tooltip: "The number of turns in which the bot actually replied to a user's question. Typically, one user question plus one bot answer counts as one answered turn.",
    avg_turns_per_engaged_session_tooltip: 'The average number of effective question-and-answer turns per engaged session, useful for observing whether users keep conversing with the chatbot.'
  },
  __Chat: {
    search_hint_text: 'Find name, tag, phone number',
    more: '+{0} more',
    send: 'Send',
    profile: 'Profile',
    message_placeholder: 'Type here...'
  },
  __Message: {
    speech: 'Speech',
    script: 'Script',
    push: 'Push'
  },
  __AI: {
    related_intent: 'Related Intent',
    related_intent_hint: 'Provide topic related to query when no concise answer',
    ai_chatbot: 'AI Chatbot',
    right_bar: {
      alias_finder: 'Alias finder',
      alias_field_hint: 'Enter keyword to find Alias',
      add_alias: 'Add Alias',
      enter_alias: 'Enter alias',
      bookmark_conversations: 'Bookmark Conversations',
      bookmark_hint: 'Bookmarked conversations from Conversation Review',
      search_bookmark: 'Search bookmark',
      remove_bookmark: 'Remove bookmark',
      acquire: 'Acquire',
      reply: 'Reply'
    },
    keyword: {
      title: 'Keyword data',
      hint: 'Train the AI to recognize questions',
      manage_category: {
        title: 'Manage Category',
        add_category: 'Add Category',
        name: 'Name of Category'
      },
      topic_data_finder: {
        title: 'Topic Data Finder',
        field_hint: 'Search question topic or sub-topic...',
        browse_sub_topic: 'Browse Sub-topic',
        sub_topic_of: 'Sub-topic of ',
        column_view: 'Column View',
        diagram_view: 'Diagram View'
      },
      filter_by_category: 'Filter by category',
      search_question_topic: 'Search question topic',
      formation: 'Formation',
      intent_id: 'Intent id'
    },
    alias: {
      title: 'Alias',
      hint: 'Increase keyword’s coverage',
      search_hint_text: 'Search Keywords, Alias',
      keyword: 'Keyword',
      exist_in_question_topic: 'Exist in {0} Question Topic',
      exist_in_question_topics: 'Exist in {0} Question Topics',
      question_topics: 'Question Topics',
      alias_of: 'Alias of',
      edit_alias_placeholder: 'Type a word and press enter to input'
    },
    mrc: {
      short_title: 'MRC',
      title: 'MRC AI Scan',
      hint: 'Auto scan document or webpage to extract Q&A content',
      refresh: 'Refresh File List',
      upload: 'Upload File for Scanning',
      search_file: 'Search File',
      preview: 'Preview',
      preview_conversation: 'Preview Conversation',
      wait_hint: 'Wait All Files to Complete Scanning',
      file_loaded: 'File Loaded',
      message_field_placeholder: 'Type your message here...',
      waiting_response: 'Waiting for response...',
      query_timeout: 'Request timed out. Please try again.',
      sources: 'Sources',
      sources_desc: 'Upload and manage documents and websites for MRC AI scanning.',
      upload_document: 'Upload Document',
      add_website: 'Add Website',
      search_sources: 'Search sources',
      type_document: 'Document',
      type_website: 'Website',
      status_crawled: 'Crawled',
      upload_to_other_lang_hint: 'Uploaded to {0}.',
      export: {
        button: 'Export Document List',
        device_name: 'Device Name',
        enabled: 'Enabled',
        disabled: 'Disabled'
      },
      upload_file_dialog: {
        title: 'Upload Document',
        file_type: 'File Type',
        url_field_hint: 'Enter url of the web',
        file_language: 'File Language'
      },
      add_website_dialog: {
        title: 'Add Website',
        url_label: 'Website URL',
        url_placeholder: 'https://example.com/...',
        invalid_url: 'Please enter a valid URL'
      },
      batch: {
        selected: '{0} selected',
        delete: 'Delete',
        enable: 'Enable',
        disable: 'Disable',
        clear: 'Clear selection',
        confirm_delete_title: 'Delete {0} document(s)?',
        confirm_delete_hint: 'The selected documents will be permanently deleted and cannot be undone.',
        confirm_enable_title: 'Enable {0} document(s)?',
        confirm_enable_hint: 'The selected documents will be enabled for MRC AI scanning.',
        confirm_disable_title: 'Disable {0} document(s)?',
        confirm_disable_hint: 'The selected documents will be excluded from MRC AI scanning.',
        success_delete: 'Queued delete for {0} document(s).',
        success_enable: 'Enabled {0} document(s).',
        success_disable: 'Disabled {0} document(s).',
        partial: '{0} succeeded, {1} failed.',
        too_many: 'You can act on at most {0} documents at once.'
      }
    },
    location_and_map: {
      title: 'Map and Location',
      hint: 'Set location and map for directory bot',
      location: {
        title: 'Location',
        add_location: 'Add Location',
        search_location: 'Search Location',
        search_category: 'Search Category',
        delete_location: 'Delete Location',
        edit_location: 'Edit Location',
        location_name: 'Location Name',
        enter_location: 'Enter Location Name',
        select_category: 'Select category',
        add_new_category: 'Add New Category',
        rename_category: 'Rename category',
        location_details: 'Location Details',
        language_specific: 'Language Specific Location Details',
        language_location_name: 'Language Specify Location Name',
        enter_language: 'Enter Language Specify Location Name',
        enter_phone: 'Enter Phone Number',
        enter_email: 'Enter Email',
        enter_description: 'Enter Description',
        address: 'Address',
        enter_address: 'Enter Address',
        opening_hours: 'Opening Hours',
        location_image: 'Location Image',
        map_and_loc: 'Map & Location',
        select_map: 'Select Map...',
        poi_title: 'Point-of-interest (POI)',
        enter_poi: 'Enter POI',
        name_of_category: 'Name of Category',
        days_of_week: 'Days of the we∂ƒek',
        add_schedule: 'Add schedule',
        delete_schedule: 'Delete schedule',
        live_chat: 'Live Chat',
        video: 'Video',
        phone_call: 'Phone Call'
      },
      map: {
        title: 'Map',
        rename_map: 'Rename map',
        name_of_map: 'Name of Map'
      }
    },
    bookmark: 'Bookmark'
  },
  __Approval: {
    change_approval: 'Changes Approval',
    last_update: 'Last Update',
    changes: 'changes',
    apostrophe_s_changes: `{0}'s Changes`,
    selected: '{0} selected',
    confirm_changes: 'Confirm Changes',
    approve: 'Approve',
    not_approve: 'Not Approve',
    cancel_approval: 'Cancel Approval',
    current_version: 'Current Version',
    new_version: 'New Version',
    section: 'Section',
    changed_by: 'Changed by',
    date_time: 'Date / Time',
    discard_changes: 'Discard Changes',
    discard_hint: 'If you leave page, any changes you have made will be lost.',
    submission: 'Submission',
    submission_hint: 'This device {0} will be locked until the submitted change(s) has been reviewed and approved.',
    approved_by_admin: 'Approved by Admin',
    unapproved_changes: 'Unapproved Changes',
    submit_to_admin: 'Submit for approval',
    wait_approval_dialog: {
      title: 'Change(s) awaiting approval',
      hint: 'Approval of system change(s) is pending',
      submitted_by: 'Changes Submitted by',
      cancel_submission: 'Cancel Submission'
    }
  },
  __QuestionTopic: {
    name_of: 'Name of {0}',
    existing_question_topic: 'Existing question topic',
    to_list: 'to List',
    activate_this: 'Activate this',
    sub_topic: 'Sub-topic',
    include: 'Include in Related Intent',
    or_change_category: 'or Change Category',
    keywords: {
      title: 'Keywords',
      tooltip_title: 'Provide keywords to let the AI understand and classify the intent of the conversation',
      multiple_hint: 'Combine multiple keywords with a “+” to let the AI to have a more precise classification',
      multiple_example: 'Apple + Juice',
      existed_hint: 'An orange tag with a keyword will be shown if you input an existed keyword’s alias',
      apple: 'Apple',
      fruit: 'Fruit',
      intent_name: 'Intent Name',
      alert_tooltip_title: 'Used by other topics:'
    }
  },
  __Response: {
    response: 'Response',
    add_response: 'Add Response',
    speech: 'Speech',
    talking_speech: 'Talking Speech',
    message: 'Message',
    selection_component: 'Selection Component',
    menu_options: 'Menu Options',
    selection_no: 'Selection No. {0}',
    text: 'Text',
    button: 'Button',
    buttons: 'Buttons',
    image_button: 'Image Button',
    quick_reply_hint: 'Hide all buttons after user selected one of them',
    card: 'Card',
    image: 'Image',
    video: 'Video',
    cards: 'Cards',
    list: 'List',
    title: 'Title',
    dropdown: 'Dropdown',
    thumbs_rating: 'Thumbs rating',
    rating_scale: 'Rating Scale',
    audio: 'Audio',
    media: 'media',
    image_size: 'Image Display size',
    chat_bubble: 'Chat bubble',
    mode: 'Mode',
    advance_setting: 'Advance Setting',
    ambassador_speech: ' Ambassador Speech',
    ambassador_speech_hint: 'Type the talking script here',
    input_disable_text: 'Disable Chatbot Textfield for this response',
    input_disable_hint: ' Make sure to add component with selection / input field',
    response_aim: {
      title: 'Response Aim',
      select_aim: 'Select Response’s Aim',
      select_mode: 'Choose Response Building Mode',
      ask_for_selection: {
        title: 'Ask for Selection',
        desc: 'Response by Giving options to user and let them select.'
      },
      give_info: {
        title: 'Give Info',
        desc: 'Response by providing info to user with text, image, video.'
      },
      custom_format: {
        title: 'Custom Format',
        desc: 'Freely edit the response format for advance user'
      },
      interactive_builder: {
        title: 'Interactive Builder',
        desc: 'Build your response without coding'
      }
    },
    response_type: {
      title: 'Response Type',
      question: 'Which type is the response?',
      text_only: 'Text-Only',
      multimedia: 'Multimedia',
      multimedia_tooltip: 'Response that combines text and image/video'
    },
    compose_response: {
      title: 'Compose Response',
      edit_response_title: 'Edit Response Config?',
      edit_response_hint: 'All the data in this response will be discarded.',
      add_card: 'Add New Card',
      delete_card: 'Delete Current Card',
      list_item: 'List Item',
      add_list: 'Add New List',
      delete_list: 'Delete Current List',
      general: 'General',
      general_message_hint: 'Suitable for casual, short and concise response',
      general_image_hint: 'Shows small image e.g. QR Code, sticker',
      none: 'None',
      show_media_only: 'Show media only',
      top_section: 'Top Section',
      top_section_message_hint: ' Suitable for long text, paragraph',
      top_section_image_hint: 'Displays large media e.g. banner, video',
      upload_image: 'Upload Image',
      image_size_hint: 'Image Display Size (Min: 1, Max: 10)',
      select_media_type: 'Select media type',
      enter_your_message: 'Enter your message',
      add_rating: 'Add User Rating Section',
      paste_video_below: 'Paste your video link below',
      paste_link_here: 'Paste your {0} link here',
      add_chat_bubble: 'Add Chat bubble',
      preview_video: 'Preview Video',
      json_format_hint: 'Press (Ctrl+I) to format json, add proper indentation and new lines',
      preview_audio: 'Preview Audio',
      downloading_preview_audio: 'Downloading Preview Audio...'
    }
  },
  __SmallTalk: {
    custom_question: 'Customizable Questions',
    content_title: 'What being shown on screen',
    extensive_title: 'Extensive Small Talk',
    extensive_hint: 'Let the AI automatically handle casual conversations',
    topic_filter: {
      title: 'Topic Filter',
      title_desc: 'Set filter for certain query and what the AI to respond',
      add_topic_group: 'Add Topic Group',
      topic_group: 'Topic Group',
      identifying: 'Identifying Topic',
      topic_to_be_identified: 'Topic to be identified',
      response: {
        title: 'Response to the topic',
        display_text: 'Display Text',
        script_placeholder: 'Enter the script to read out',
        text_placeholder: 'Enter the text message to show'
      },
      delete: 'Delete Topic Group'
    },
    prompt: {
      title: 'Prompt',
      set_prompt: 'Set Prompt',
      placeholder: 'Write the prompt here'
    }
  },
  __Conversation: {
    others: '+{0} others',
    download_tooltip: 'Download Conversations (.xlsx)',
    add_filter: 'Add Filter',
    filter: {
      category_title: 'Filter by Question Topic’s Category',
      exclude_title: 'Exclude Reply’s Keyword',
      show_only: 'Show Only',
      fallback: 'Fallback Conversation',
      bookmarked: 'Bookmarked'
    },
    filter_dialog: {
      category: {
        title: 'Filter by Category',
        field_title: 'Select Question Topic’s Category'
      },
      exclude: {
        title: 'Exclude Conversation',
        field_title: 'Exclude conversation if a reply contains:',
        field_hint: 'Enter the word / phrase in reply to exclude'
      }
    },
    search_hint_text: 'Search Conversation',
    column: 'Column',
    fixed_column: 'Fixed Column',
    intent_trained: 'Trained',
    intent_trained_detail: 'Trained to Intent',
    intent_not_trained: 'Not Trained',
    train_topic: 'Train Existing Question Topic',
    train_topic_hint: 'Choose an existing question topic to train',
    unbookmark: 'Unbookmark conversation',
    bookmark: 'Bookmark conversation',
    add_bookmark_menu_title: 'Add to bookmarks',
    exclude: 'Exclude',
    remarks: 'Remarks',
    play_recording: 'Play Recording'
  },
  __EventManager: {
    current_event: 'Current event',
    select_event_hint: 'Select an event on the event list',
    event_library: 'Event Library',
    saved_event: 'Saved Event',
    event: 'Event',
    quiz: 'Quiz',
    name: 'Name',
    languages: 'Languages',
    created_date: 'Created Date',
    browse_quiz_library: 'Browse Quiz Library',
    add_new_event: 'Add New Event',
    times: 'time(s)',
    quit_editing: {
      title: 'Unfinished Edit',
      hint: 'If you proceed, you will lose all the changes that you have made.',
      keep_editing: 'Keep Editing',
      discard_changes: 'Discard Changes'
    },
    event_detail: {
      end_event: 'End Event',
      event_flow: 'Event Flow',
      activity: 'Activity',
      duplicate_flow: 'Duplicate this flow to...',
      add_activity: 'Add Activity',
      delete_activity: 'Delete Activity',
      delete_activity_hint: 'All your edits in this activity will be deleted and cannot be undone.',
      control_setting: 'Control Setting',
      play_video: {
        title: 'Play Video',
        video_repeat_options: 'Video Repeat Options',
        once: 'Play Only Once',
        endless: 'Endless Loop',
        repeat: 'Repeat',
        repeat_times: 'Repeat Times',
        no_video_yet: 'No video yet',
        add_video: 'Add Video',
        video_file_name: 'Video File Name'
      },
      text_to_speech: {
        title: 'Text to Speech',
        countdown_text: 'Countdown to the next activity after the speech',
        sec: 'sec.',
        image_banner: 'Image Banner'
      },
      quiz: {
        title: 'Quiz',
        quiz_selected: 'Quiz Selected',
        no_version_alert: 'No {0} version found in this Quiz'
      },
      nlp_faq: {
        title: 'NLP FAQ',
        nlp_faq_lang: 'NLP FAQ Language'
      }
    },
    quiz_library: {
      title: 'Quiz Library',
      quiz_list: 'Quiz List',
      delete_quiz: 'Delete Quiz',
      duplicate_quiz: 'Duplicate Quiz',
      general_page_settings: 'General Page Settings',
      onboard: 'Onboard Page',
      correct: 'Correct Page',
      incorrect: 'Incorrect Page',
      ending: 'Ending Page',
      retry: 'Retry Page',
      enable_random_pick: 'Enable Random Pick',
      num_of_question: 'Number of Question to ask',
      questions: 'Questions',
      add_question: 'Add Question',
      delete_question: 'Delete Question',
      no_quiz_yet: 'No Quiz yet',
      no_quiz_hint: 'Start by adding a new quiz',
      all_questions: 'All Questions'
    },
    question: {
      question: 'Question',
      content: 'Content',
      textual: 'Textual',
      textual_hint: 'Enter the textual content to display',
      speech: 'Speech',
      speech_hint: 'Enter the talking script',
      include_image: 'Include Image',
      max_attempt: 'Max Attempt',
      show_hints_when_failed: 'Show Hints when failed',
      optional: 'Optional',
      selection_button: 'Selection Button',
      correct_answer: 'Correct Answer',
      correct_answer_hint: 'Enter the answer or its related keyword...',
      add_as_answer: '+ Add as Answer',
      hints: 'Hints',
      hints_hint: 'Enter hints to display',
      hints_speech_hint: 'Enter the hint talking script'
    }
  },
  __InterfaceSetting: {
    general_section: 'General Section',
    top_section: 'Top Section',
    bottom_section: 'Bottom Section',
    components: 'Components',
    header: 'Header',
    second: 'second',
    carousel_banner: {
      title: 'Carousel Banner',
      add_banner: 'Add Banner',
      time_between: 'Time between Banners',
      set_as_first: 'Set as the First Banner',
      delete_banner: 'Delete Banner'
    },
    bottom_menu: {
      title: 'Bottom Menu',
      add_item: 'Add Item',
      delete_item: 'Delete Item',
      change_image: 'Change Image',
      payload: 'Payload'
    },
    directory: {
      title: 'Directory',
      search_placeholder: 'Search Unit, Occupant, Phone No., Email',
      add_unit: 'Add Unit',
      update_info: 'Update Info',
      phone_number: 'Phone Number',
      email: 'Email',
      unit: 'Unit',
      occupant_name: 'Occupant Name',
      phone_no: 'Phone No.',
      live_chat: 'Live Chat',
      show_video: 'Show Video',
      phone_call: 'Phone Call'
    },
    logo: 'Logo',
    right_icon: 'Right Icon',
    change: 'Change',
    use_picture: 'Use picture',
    avatar: {
      title: 'avatar',
      virtual_avatar: 'Virtual Avatar',
      create: 'Create avatar',
      delete: 'Delete Avatar',
      date_created: 'Date Created',
      in_use: 'Ambassador In Use',
      set: 'Set as Ambassador',
      avatar_name: 'Avatar Name',
      create_dialog: {
        submit: 'Submit for Production',
        generating: 'Generating Avatar...',
        generating_hint: 'This could takes a few minutes',
        panel_title: 'AI Avatar Generator',
        panel_desc: 'Tell the AI your preferences to generate your own avatar',
        generate: 'Generate',
        basic_properties: 'Basic Properties',
        gender: 'Gender',
        age: 'Age',
        race: 'Race',
        optional_style: 'Optional Style',
        dressing_style: 'Dressing Style',
        hair_color: 'Hair Color',
        hair_style: 'Hair Style',
        accessories: 'Accessories',
        props: {
          male: 'Male',
          female: 'Female',
          young: 'Young',
          old: 'Old',
          child: 'Child',
          asian: 'Asian',
          black: 'Black',
          indian: 'Indian',
          white: 'White',
          business__suit: 'Business Suit',
          student: 'Student',
          blonde: 'Blonde',
          brown: 'Brown',
          short: 'Short',
          long: 'Long',
          wavy: 'Wavy',
          glasses: 'Glasses',
          earring: 'Earring',
          headphone: 'Headphone'
        }
      },

      rename_dialog: {
        rename_avatar: 'Rename Avatar'
      },
      submit_dialog: {
        title: 'Submit Avatar for Production',
        name_placeholder: 'Create a name for the avatar',
        hint: 'The production takes around 15-30 minutes. You can check the progress in the virtual avatar page.',
        start_production: 'Start Production'
      }
    },
    idle_screen: {
      title: 'Idle Screen',
      display_mode: 'Display Mode',
      mode: 'mode',
      time_between: 'Time between Images',
      set_as_first: 'Set as first image',
      add_image: 'Add image',
      delete_image: 'Delete image',
      add_video: 'Add video',
      no_item_hint: 'No item yet',
      start_adding_hint: 'Start adding item to display'
    },
    weather: {
      title: 'Weather',
      select_region: 'Select Region',
      hint: 'Choose which region’s weather to display on the device.',
      hong_kong: 'Hong Kong',
      taiwan: 'Taiwan'
    },
    branding: {
      title: 'Branding Images',
      description: 'Customize the background, logo and QR code images shown on the device.',
      background: 'Background',
      logo: 'Logo',
      qr: 'QR Code',
      hint: 'Supported formats: PNG, JPG, WEBP. Max size 8MB.',
      using_default: 'Using default image',
      upload: 'Upload',
      change: 'Change',
      reset: 'Reset to default',
      done: 'Done',
      cancel: 'Cancel',
      upload_file: 'Upload File',
      filepond_hint: 'Drag & Drop your image here or Browse...'
    }
  },
  __NotificationBanner: {
    new_call: 'You have new incoming call',
    view_call: 'View call'
  },
  __LiveVideo: {
    offline_hours_of_live_video: 'Offline Hours of Live Video',
    live_video_call_notification: 'Live Video Call Notification',
    email: 'Email',
    sms: 'SMS',
    missed: 'Missed',
    call_in_progress: 'Call In Progress',
    incoming_call: 'Incoming Call',
    called: 'Called',
    no_incoming_video_call: 'No incoming Video Call',
    view_past_call: 'View Past Call',
    end_call: 'End Call',
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      weekdays: 'Weekdays',
      weekends: 'Weekends'
    },
    short_days: {
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
      sun: 'Sun'
    },
    set_offline_hour_of_live_video: 'Set offline hour of Live Video',
    days_of_the_week: 'Days of the week',
    delete_schedule: 'Delete schedule',
    add_schedule: 'Add schedule',
    offline_message_on_ambassador: 'Offline Message on Ambassador',
    notification_hint: 'Set how you want to receive notification for any new live video call request',
    live_video_call_history: 'Live Video Call History',
    date_filter: 'Date Filter',
    filter_time: 'Filter Time',
    okay: 'Okay',
    from: 'From',
    to: 'To'
  },
  __AdminSetting: {
    admin: 'admin',
    user: 'user',
    users: {
      title: 'Users',
      desc: 'Add or delete users, change password, permission settings',
      add_user: 'Add User',
      change_password: 'Change Password',
      user_mngt_dialog: {
        title: { add: 'Add new user', edit: 'Change Password', reset: 'Reset Password' },
        role: 'Role',
        name: 'Name',
        email: 'Email',
        post: 'Post',
        username: 'Username',
        password: { add: 'New Password', edit: 'Edit Password', reset: 'Reset Password', current: 'Current Password' },
        password_hint: 'Password must contain at least one uppercase letter, one lowercase letter, one number, and one symbol'
      }
    },
    logs: {
      title: 'Logs',
      desc: 'Review records of the system events',
      export_logs: 'Export Logs',
      search: 'Search',
      date_filter: 'Date Filter',
      user_id: 'User ID',
      action: 'Action',
      log_datetime: 'Log Datetime'
    }
  },
  __DeleteDialog: {
    record: 'record',
    avatar_hint: 'The avatar will be permanently deleted and cannot be undone.',
    record_hint: 'The record will be permanently deleted and cannot be undone.',
    quiz_hint: 'The quiz will be deleted and cannot be undone.',
    question_hint: 'The question will be deleted and cannot be undone.',
    keyword: 'keyword',
    unit: 'unit',
    category: 'category',
    question: 'question',
    response: 'response',
    user: 'user',
    mrc: 'mrc',
    avatar: 'avatar',
    quiz: 'quiz'
  },
  __SnackBar: {
    success: '{0} Success',
    add: 'Add {0} Success',
    adding: 'Adding {0}...',
    delete: 'Delete {0} Success',
    deleting: 'Deleting {0}...',
    edit: 'Edit {0} Success',
    editing: 'Editing {0}...',
    load: 'Load {0} success',
    loading: 'Loading {0}...',
    rename: 'Rename success',
    renaming: 'Renaming...',
    update: 'Update {0} success',
    updating: 'Updating {0}...',
    upload: 'Upload {0} success',
    uploading: 'Uploading {0}...',
    authenticating: 'Authenticating...',
    device_list: 'Loading device list...',
    logging_out: 'Logging out...',
    session_expired: 'Your session has expired. Please log in again.',
    incorrect_data_found: 'Incorrect data found, please check again.',
    text_error: 'Text cannot be empty',
    missing_member_file: 'Missing Member File',
    update_question_topic_status: 'Updating Question Topic’s Status...',
    server_occur_error: 'Server Occur Error',
    bookmarking: 'Bookmarking...',
    downloading: 'Downloading...',
    download: 'Download Success',
    posting_message: 'Posting message',
    message_posted: 'Message posted',
    duplicated_flow: 'Duplicated flow',
    create: 'Create {0} Success',
    creating: 'Creating {0}...',
    duplicate: 'Duplicate {0} Success',
    duplicating: 'Duplicating {0}...',
    setting_current_event: 'Setting Current Event',
    current_event: 'Current Event set',
    ending_event: 'Ending Event',
    end_event: 'End Event Success',
    fields_incompleted: 'Fields incompleted',
    submit: 'Submit success',
    submitting: 'Submitting ...',
    cancel: 'Cancel success',
    canceling: 'Canceling ...',
    exporting_log: 'Exporting Log'
  },
  __DatatableHeader: {
    file_name: 'File Name',
    date_uploaded: 'Date Uploaded',
    phone: 'Phone',
    tag: 'Tag',
    date: 'Date',
    intent_identified: 'Intent Identified',
    intent_category: 'Intent Category',
    response_time: 'Response Time',
    score: 'Score',
    status: 'Status',
    user_rating: 'User Rating',
    user_comment: 'User Comment',
    file_name_or_source: 'File Name / Source',
    type: 'Type',
    enable: 'Enable'
  }
}
